import { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLazyGetVehicleStatusQuery } from "../../../../Redux/service/Dashboard";
import Popup from "../../../Helpers/Popup/Popup";
import trans from "../../../../utils";
import Close from "../../../Helpers/CloseBtn/Close";
import Searchbar from "../../../Helpers/Searchbar/Searchbar";
import AntdTable from "../../../antd/Table/Table";
import { filtrationcontext } from "../../../../context/Filtercontext";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import { formatDateString } from "../../../../JsHelpers/DateFormat";
import { SpeedUnit } from "../../../../JsHelpers/PlatformUnits";
import { useSelector } from "react-redux";
import axios from "axios";

export default function VehicleStatusModal({ show, onHide, status }) {
  const { limit, setLimit, setSearchQuery } = useContext(filtrationcontext);
  const [query, setQuery] = useState("");
  const [tableData, setTableData] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [sort, setSort] = useState({
    by: "",
    order: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const inf = useSelector((state) => state.users.user);
  const [addresses, setAddresses] = useState({});

  const [fetchStatusData, { data, isFetching }] =
    useLazyGetVehicleStatusQuery();

  const handleSearch = (e) => {
    const val = e.target.value;
    setQuery(val);
    setSearchQuery(val);
    setCurrentPage(1); // Reset page on new search
  };

  useEffect(() => {
    const fetchData = async () => {
      if (status && show) {
        try {
          const result = await fetchStatusData({
            status,
            page: currentPage,
            pageSize: limit,
            sortBy: sort.by,
            sortOrder: sort.order,
            search: query,
          }).unwrap();
          setTableData(result.data || []);
          setTotalResults(result.totalResults || 0);
        } catch (error) {
          console.error("Fetch vehicle status failed:", error);
          setTableData([]);
          setTotalResults(0);
        }
      }
    };
    fetchData();
  }, [status, show, currentPage, limit, sort, query, fetchStatusData]);

  useEffect(() => {
    return () => {
      setSearchQuery("");
    };
  }, [setSearchQuery]);

  const fetchGeoCodePosition = async (lat, lon, deviceUniqueId) => {
    const key = `${deviceUniqueId}-${lat}-${lon}`;
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${lon}&zoom=18&format=jsonv2`
      );
      const newAddress = `${response.data.display_name}`;
      setAddresses((prevAddresses) => {
        const updatedAddresses = { ...prevAddresses };
        updatedAddresses[key] = {
          deviceUniqueId,
          lat,
          lon,
          newAddress,
        };
        return updatedAddresses;
      });
    } catch (error) {
      console.error("Error fetching geocode position:", error);
    }
  };

  const getAddressForDevice = (deviceUniqueId, lat, lon) => {
    const key = `${deviceUniqueId}-${lat}-${lon}`;

    const addressObj = addresses[key];
    if (addressObj) {
      return (
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${lat},${lon}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary hover-undreline"
        >
          {addressObj.newAddress}
        </a>
      );
    }
    return null;
  };

  const columns = [
    { title: trans("Vehicle"), dataIndex: "name", width: 150, sorter: true },
    { title: trans("IMEI"), dataIndex: "imei", width: 150, sorter: true },
    {
      title: trans("plate number"),
      dataIndex: "plateNumber",
      width: 150,
    },
    {
      title: trans("Group Name"),
      dataIndex: "groupName",
      width: 150,
      sorter: true,
    },
    {
      title: trans("Last Update"),
      dataIndex: "lastUpdate",
      width: 180,
      sorter: true,
      render: (value) => (value ? value : "- - - - -"),
    },
    {
      title: trans("Speed"),
      dataIndex: "speed",
      width: 100,
      sorter: true,
      render: (value) => SpeedUnit(value, inf.attributes?.speedUnit || "kn"),
    },
    {
      title: trans("Address"),
      width: 250,
      render: (_, record) => {
        const hasCoords = record.latitude && record.longitude;
        const content = hasCoords
          ? getAddressForDevice(
              record.imei,
              record.latitude,
              record.longitude
            ) || trans("Get Address")
          : "Coordinates Missing";

        return (
          <span
            className={`text-primary ${hasCoords ? "cursor" : "text-muted"}`}
            onClick={() => {
              if (hasCoords) {
                fetchGeoCodePosition(
                  record.latitude,
                  record.longitude,
                  record.imei
                );
              }
            }}
          >
            {content}
          </span>
        );
      },
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.field) {
      setSort({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    }
  };

  return (
    <Popup show={show} size="lg">
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle
            headtitle={`${trans(status)} ${trans("Vehicles")}`}
            nospace={true}
          />
        </Modal.Title>
        <Close style="close-32 close" close={onHide} img="Close" />
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        <Searchbar
          style="search search-dark input-group"
          path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
          placeholder={trans("Search")}
          value={query}
          onChange={handleSearch}
        />
        <div className="mt-3 table-parent">
          <AntdTable
            columns={columns}
            dataSource={tableData}
            loading={isFetching}
            pageSize={limit}
            totalItems={totalResults}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
            onLimitChange={(newLimit) => {
              setLimit(newLimit);
              setCurrentPage(1);
            }}
            onTableChange={handleTableChange}
            scrollY={300}
          />
        </div>
      </Modal.Body>
    </Popup>
  );
}
